export class TemplateBooleanInspectionInput {
    description = '';
    constructor(booleanInspection) {
        if (booleanInspection) {
            this.description = booleanInspection.description;
        }
    }
}
